pn-illustration {
  display: inline-block;

  &[data-fill] {
    display: block;
  }

  > svg {
    width: var(--pn-width);
    height: var(--pn-height);
    display: block;
  }
}
